import { __awaiter } from 'tslib';
import { Injectable, NgModule } from '@angular/core';

/**
 * Servicio para encriptar y desencriptar datos usando AES-GCM 256.
 */
import * as ɵngcc0 from '@angular/core';
class CryptoService {
    constructor() {
        this.ivLength = 12;
    }
    /**
     * Encripta una cadena de texto utilizando AES-GCM.
     *
     * @param key Clave de cifrado en texto plano. Debe tener la longitud adecuada (ej. 16, 24 o 32 caracteres para AES-128/192/256).
     * @param data Texto plano a encriptar.
     * @returns Una promesa que resuelve con el resultado encriptado en base64, incluyendo el IV concatenado al inicio.
     * @throws Lanza un error si ocurre un fallo durante el proceso de cifrado.
     */
    encryptData(key, data) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const encoder = new TextEncoder();
                const encodedKey = encoder.encode(key);
                const encodedData = encoder.encode(data);
                const cryptoKey = yield crypto.subtle.importKey('raw', encodedKey, { name: 'AES-GCM' }, false, ['encrypt']);
                const iv = crypto.getRandomValues(new Uint8Array(this.ivLength));
                const encryptedBuffer = yield crypto.subtle.encrypt({ name: 'AES-GCM', iv }, cryptoKey, encodedData);
                const encryptedBytes = new Uint8Array(encryptedBuffer);
                const combined = new Uint8Array(iv.length + encryptedBytes.length);
                combined.set(iv, 0);
                combined.set(encryptedBytes, iv.length);
                return btoa(String.fromCharCode(...combined));
            }
            catch (error) {
                console.error('Encryption failed:', error);
                throw error;
            }
        });
    }
    /**
     * Desencripta un texto cifrado en AES-GCM
     *
     * @param key Clave original utilizada para el cifrado.
     * @param combinedData Cadena en base64 que contiene el IV concatenado con los datos cifrados.
     * @returns Una promesa que resuelve con el texto plano desencriptado.
     * @throws Lanza un error si la clave es incorrecta o si los datos están corruptos.
     */
    decryptData(key, combinedData) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const encryptedArray = Uint8Array.from(atob(combinedData), c => c.charCodeAt(0));
                const iv = encryptedArray.slice(0, this.ivLength);
                const ciphertext = encryptedArray.slice(this.ivLength);
                const encoder = new TextEncoder();
                const encodedKey = encoder.encode(key);
                const cryptoKey = yield crypto.subtle.importKey('raw', encodedKey, { name: 'AES-GCM' }, false, ['decrypt']);
                const decryptedBuffer = yield crypto.subtle.decrypt({ name: 'AES-GCM', iv }, cryptoKey, ciphertext);
                return new TextDecoder().decode(decryptedBuffer);
            }
            catch (error) {
                console.error('Decryption failed:', error);
                throw error;
            }
        });
    }
}
CryptoService.ɵfac = function CryptoService_Factory(t) { return new (t || CryptoService)(); };
CryptoService.ɵprov = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjectable({ token: CryptoService, factory: CryptoService.ɵfac });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(CryptoService, [{
        type: Injectable
    }], function () { return []; }, null); })();

/**
 * Módulo que provee el servicio de encriptación y desencriptación.
 */
class CryptoModule {
}
CryptoModule.ɵfac = function CryptoModule_Factory(t) { return new (t || CryptoModule)(); };
CryptoModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: CryptoModule });
CryptoModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ providers: [CryptoService] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(CryptoModule, [{
        type: NgModule,
        args: [{
                providers: [CryptoService]
            }]
    }], null, null); })();

/*
 * Public API Surface of encryption
 */

/**
 * Generated bundle index. Do not edit.
 */

export { CryptoModule, CryptoService };

